// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OverFlowMenuUI__OverFlowMenu___1E4D5{filter:brightness(200%)}", ""]);
// Exports
exports.locals = {
	"OverFlowMenu": "OverFlowMenuUI__OverFlowMenu___1E4D5"
};
module.exports = exports;
